import { render, staticRenderFns } from "./ProjektDetailansicht.vue?vue&type=template&id=214e92dc&scoped=true&"
import script from "./ProjektDetailansicht.vue?vue&type=script&lang=js&"
export * from "./ProjektDetailansicht.vue?vue&type=script&lang=js&"
import style0 from "./ProjektDetailansicht.vue?vue&type=style&index=0&id=214e92dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e92dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VContainer,VSnackbar})
